'use client';

import { PropsWithClassname } from '@/app/types';
import classNames from 'classnames';

import { CreateDonationRequestModeEnum } from '@/app/api';

import { DonateBoxButtons } from '@/app/components/DonateBoxCommercial/components/DonateBoxButtons';
import TabsSelect, { TabsSelectOption } from '@/app/components/TabsSelect/TabsSelect';
import { DonateBoxContainer } from '@/app/components/DonateBoxCommercial/components/DonateButtonsContainer';
import { useTranslation } from 'react-i18next';

interface DonateBoxProps extends PropsWithClassname {
  selectedDonationMode: CreateDonationRequestModeEnum;
  onChangeSelectedDonationMode: (nextDonationMode: CreateDonationRequestModeEnum) => void;
  donationModeOptions: TabsSelectOption<CreateDonationRequestModeEnum>[];
  isProjectLongTerm: boolean;
  onShareButtonClick: () => void;
  onDonateClick: () => void;
}

const DonateBoxCommercial = ({
  donationModeOptions,
  selectedDonationMode,
  isProjectLongTerm,
  onChangeSelectedDonationMode,
  onShareButtonClick,
  className,
  onDonateClick,
}: DonateBoxProps) => {
  const { t } = useTranslation();
  return (
    <div className={classNames(className, '')}>
      {isProjectLongTerm && (
        <TabsSelect<CreateDonationRequestModeEnum>
          value={selectedDonationMode}
          onChange={onChangeSelectedDonationMode}
          options={donationModeOptions}
          className="my-[16px]"
        />
      )}
      <div className="block lg:hidden">
        <DonateBoxContainer
          supportButtonTestId="mobile-static-support-button"
          className="py-[20px] lg:py-[12px]"
          onDonateClick={onDonateClick}
          onShareButtonClick={onShareButtonClick}
        />
      </div>
      <div className="hidden lg:block">
        <DonateBoxButtons
          supportButtonTestId="desktop-static-support-button"
          shareButtonText={t('components.DonateBox.shareProject')}
          className="py-[20px] lg:py-[12px]"
          onDonateClick={onDonateClick}
          onShareButtonClick={onShareButtonClick}
        />
      </div>
    </div>
  );
};

export default DonateBoxCommercial;
